import { ModuleWithProviders, NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { RouterModule } from '@angular/router'

import { SharedModule } from '../shared/shared.module'
import { AuthRoutingModule } from './auth-routing.module'

import { CreateAccountContainer } from './containers/create-account-container'
import { ForgotAccountContainer } from './containers/forgot-account-container'
import { LoginContainer } from './containers/login-container'
import { ResetPasswordContainer } from './containers/reset-password-container'
import { ActivateContainer } from './containers/activate-container/'
import { LogoutContainer } from './containers/logout-container/logout.container'
import { CustomerSelectionContainer } from './containers/customer-selection-container'
import { VerifyEmailContainer } from './containers/verify-email-container/verify-email-container.component'

import { LoginPageComponent } from './components/login-page'
import { CreateAccountPageComponent } from './components/create-account-page'
import { ForgotAccountPageComponent } from './components/forgot-account-page'
import { CreateSuccessPageComponent } from './components/create-success-page'
import { ResetAccountSuccessPageComponent } from './components/reset-account-success-page'
import { ResetPasswordPageComponent } from './components/reset-password-page'
import { ActivatePageComponent } from './components/activate-page'
import { CustomerSelectionPageComponent } from './components/customer-selection-page'

import { AccountService } from './services/account.service'
import { UserService } from './services/user.service'
import { AuthGuard } from './services/auth-guard-service'

import { AuthEffects } from './effects/auth.effects'
import { AccountEffects } from './effects/account'
import { UserEffects } from './effects/user.effects'

import { reducers } from './reducers';
import { CustomerEffects } from './effects/customer.effects';
import { CustomersService } from './services/customers.service';
import { LoggedInGuard } from './services/logged-in-guard-service';
import { ResetPasswordSuccessPageComponent } from './components/reset-password-success-page/reset-password-success-page.component';
import { VerifyEmailPageComponent } from './components/verify-email-page/verify-email-page.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule
  ],
  declarations: [
    LoginContainer,
    CreateAccountContainer,
    ForgotAccountContainer,
    ActivateContainer,
    LoginPageComponent,
    CreateAccountPageComponent,
    ForgotAccountPageComponent,
    CreateSuccessPageComponent,
    ResetPasswordSuccessPageComponent,
    ResetAccountSuccessPageComponent,
    ResetPasswordContainer,
    ResetPasswordPageComponent,
    ActivatePageComponent,
    LogoutContainer,
    CustomerSelectionPageComponent,
    CustomerSelectionContainer,
    VerifyEmailContainer,
    VerifyEmailPageComponent
  ]
})
export class AuthModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: RootAuthModule,
      providers: [AuthGuard, LoggedInGuard, AccountService, UserService, CustomersService]
    }
  }
 }

@NgModule({
  imports: [
    AuthModule,
    AuthRoutingModule,
    StoreModule.forFeature('auth', reducers),
    EffectsModule.forFeature([AuthEffects, AccountEffects, UserEffects, CustomerEffects])
  ]
})
export class RootAuthModule {}
